import { Box, ButtonAppearance, ButtonSize, IconSize, TextFieldSize } from '@bechtel/gds';
import { Scalars } from '@bechtel/types';
import { t } from '@lingui/macro';
import { isEqual } from 'lodash';
import { FC } from 'react';
import { BlockDrawerValuesProps } from '../form-data';
import { SearchCanvasButtonStyled, SearchFieldComponentStyled, SearchFieldStyled, StyledIcon } from './styled';
interface BlockCardSearchProps {
  toggle: () => void;
  setSearchQuery: (e) => void;
  searchQuery: Scalars['String'];
  defaultValues: BlockDrawerValuesProps;
  drawerValues: BlockDrawerValuesProps;
}

export const BlockCardSearch: FC<BlockCardSearchProps> = ({
  toggle,
  defaultValues,
  drawerValues,
  setSearchQuery,
  searchQuery,
}) => {
  return (
    <Box
      justifyContent={{ sm: 'flex-start' }}
      pb={{ sm: '300' }}
      data-testid="block-card-search-wrap"
      flexWrap={{ sm: 'wrap' }}
    >
      <Box style={{ maxWidth: '292px' }} flexBasis={{ sm: '0' }} flexGrow={{ sm: '1' }} flexShrink={{ sm: '1' }}>
        <SearchFieldStyled data-testid="block-card-search-text">
          <SearchFieldComponentStyled
            size={TextFieldSize.LARGE}
            iconSize={IconSize.MEDIUM}
            placeholder={t`Search`}
            type="search"
            onChange={(e) => setSearchQuery(e.target.value)}
            value={searchQuery}
          />
        </SearchFieldStyled>
        <Box
          ml={{ sm: '400' }}
          css={`
            ${({ theme }) => `max-width: ${theme.spacings[800]};`}
          `}
        >
          <SearchCanvasButtonStyled
            data-testid="block-card-search-canvas"
            isDefaultFilterChange={!isEqual(drawerValues, defaultValues)}
            onClick={toggle}
            appearance={ButtonAppearance.SECONDARY}
            size={ButtonSize.LARGE}
          >
            <StyledIcon
              icon="sliders-v"
              size={IconSize.LARGE}
              fillColor={!isEqual(drawerValues, defaultValues) ? 'white' : ''}
            />
          </SearchCanvasButtonStyled>
        </Box>
      </Box>
    </Box>
  );
};
